import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { FORGOT_PASSWORD_ROUTES } from '../../features/auth/forgot-password/forgot-password.routes';
import { LANDING_ROUTES } from '../../features/auth/landing/landing.routes';
import { LOGIN_ROUTES } from '../../features/auth/login/login.routes';
import { LOGOUT_ROUTES } from '../../features/auth/logout/logout.routes';
import { PRIVACY_POLICY_ROUTES } from '../../features/auth/privacy-policy/privacy-policy.routes';
import { SIGNUP_ROUTES } from '../../features/auth/signup/signup.routes';
import { VERIFY_EMAIL_ROUTES } from '../../features/auth/verify-email/verify-email.routes';
import { VERIFY_RESET_PASSWORD_ROUTES } from '../../features/auth/verify-reset-password/verify-reset-password.routes';

const routes: Routes = [
    ...FORGOT_PASSWORD_ROUTES,
    ...LANDING_ROUTES,
    ...LOGIN_ROUTES,
    ...LOGOUT_ROUTES,
    ...SIGNUP_ROUTES,
    ...VERIFY_EMAIL_ROUTES,
    ...VERIFY_RESET_PASSWORD_ROUTES,
    ...PRIVACY_POLICY_ROUTES,
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule],
})
export class AuthLayoutRoutingModule {}
